import { HeaderSlot } from '../../../../utils/constants';
import { isEmptyData } from '../../../../utils/helper';
import { RelativeHeader } from '../../Header';
import ImageLoader from '../../ImageLoader';

const ArticleDetail = (props) => {
	const { onClose, item } = props;

	const headerProps = {
		slots: {
			left: {
				content: HeaderSlot.BACK,
				route: onClose,
				className: '!opacity-100 transform !translate-y-0',
			},
			center: {
				content: HeaderSlot.NAME,
				title: 'News & Article',
				className: '!opacity-100 !translate-y-0 ml-2',
			},
		},
		parent: {
			border: {
				bottom: true,
			},
		},
	};

	const decodeHTML = (html) => {
		const txt = document.createElement('textarea');
		txt.innerHTML = html;
		return txt.value;
	};

	const handleClick = (link) => {
		const validUrl = link.startsWith('http') ? link : `https://${link}`;
		window.open(validUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<>
			<div className='m-4'>
				<RelativeHeader {...headerProps} />
				<div className='-mx-4'>
					<ImageLoader src={item?.cmspageBannerImage} className='h-full w-full object-cover object-center' />
				</div>
				<div className={`mt-4 ${isEmptyData(item?.actionUrl) ? 'mb-10' : 'mb-4'} text-gray-500 text-xs leading-relaxed [&_ul]:list-disc [&_ul]:pl-5`} dangerouslySetInnerHTML={{ __html: decodeHTML(item.cmspageDescription) }} />
				<div className={`bg-white p-4 shadow-custom -mx-4 -mb-4 ${isEmptyData(item?.actionUrl) && 'hidden'}`}>
					<button className='w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm p-3 border-0 items-center' id='link' onClick={() => handleClick(item?.actionUrl)}>
						<div>{item?.actionName || 'Daftar'}</div>
					</button>
				</div>
			</div>
		</>
	);
};

export default ArticleDetail;
